import React, { useState, useEffect } from "react";
import DatePicker from 'react-datepicker';
import axios from "axios";
import './ATRZODReportWithFilters.css'
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select from 'react-select';
import { format } from 'date-fns';
import ExcelJS from 'exceljs';
import pomisHeaderImage from './pomisHeader.jpeg';

import pds from './pds.PNG';
const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const ATRZODReportWithFilters = () => {



    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);

    const [fpsUniqueId, setFpsUniqueId] = useState("");
    const [fpshops, setFPShops] = useState([]);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState(null);  // Define setError here
    const [isLoading, setIsLoading] = useState(false);

    const [showTable, setShowTable] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [sortedStockData, setSortedStockData] = useState([]);
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    // Determine the minimum date for the endDate date picker
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(2025, 0, 1); // January 1st of current year



    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const handleStartDateChange = (date) => {
        setStartDate(date);
        setShowCalendar(false); // Hide the calendar after date selection
        setEndDate('');
        // setData([]);                    // Clear the district/subdivision data

        setShowTable(false);           // Hide the table
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
        setShowEndCalendar(false); // Hide the calendar after date selection


    };
    const handleEndDateIconClick = () => {
        // Only show the calendar for endDate if startDate is selected
        if (startDate) {
            setShowEndCalendar(true);
        }
    };
    const handleClear = () => {
        setStartDate("");
        setEndDate("");
        setShowTable(false);



        // Optional: Clear any error messages

    };
    const generatePDF = () => {


        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [290, 300] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });

        doc.setFontSize(18);
        doc.addImage(pds, 'jpeg', 9.5, -1, 273, 43);  // Image format: 'PNG'
        // Assuming doc is an instance of jsPDF

        const pageWidth = doc.internal.pageSize.width;

        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position

        // Set the report title with a styled color
        // Set the report title with a styled color
        const title = 'ATR  Report - Zero Office Day';  // Title for the report

        // Get the page width
        const titleWidth = doc.getTextWidth(title); // Get the width of the title

        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);

        // Increase the y-position to move the title further down
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background

        // Draw the title text in the center of the page
        doc.text(title, (pageWidth - titleWidth) / 2, titleYPosition); // Position the title at the new y position

        // Mapping IDs to names for each field
        const district = districts.find(d => String(d.id) === String(districtId));
        const subDivision = subDivisions.find(s => String(s.id) === String(subDivisionId));
        const block = blocks.find(b => String(b.id) === String(blockId));
        const panchayat = panchayats.find(p => String(p.id) === String(panchayatId));
        const fps = fpshops.find(f => String(f.id) === String(fpsUniqueId));
        //const fpsName = fps ? fps.fpsId : fpsUniqueId; // This line uses fpsId from the found object or falls back to fpsUniqueId.

        // const fps = Object.values(fpshops).find(f => String(f.id) === String(fpsUniqueId));
        const districtName = district ? district.districtName : '';
        const subDivisionName = subDivision ? subDivision.subDivisionName : '';
        const blockName = block ? block.blockName : '';
        const panchayatName = panchayat ? panchayat.panchayatName : '';
        const fpsName = fps ? fps.fpsId : fpsUniqueId; // If not found in fpshops, use the typed fpsId
        //console.log("fpsName:", fpsName);
        // console.log(fpsUniqueId);
        // console.log(" fpsId:", fpsUniqueId);

        // Date formatting (if dates are present)
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black

        let currentYPosition = 55.21;
        let xPosition = 10;
        const columnSpacing = 90; // Space between columns

        // Check if there is data for each table
        const hasDistrict = districtName !== '';
        const hasSubDivision = subDivisionName !== '';
        const hasBlock = blockName !== '';

        const hasPanchayat = panchayatName !== '';
        const hasFps = fpsName !== '';

        const hasFromDate = fromDate !== '';
        const hasToDate = toDate !== '';

        // First Table (District, Sub Division, Block)
        if (hasDistrict || hasSubDivision || hasBlock) {
            // First Table (District, Sub Division, Block)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the first table

            // Set font to normal for labels
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);

            // Add labels only if data exists for the fields
            if (hasDistrict) {
                doc.text("District:", xPosition + 5, currentYPosition + 5);
            }
            if (hasSubDivision) {
                doc.text("Sub Division:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }
            if (hasBlock) {
                doc.text("Block:", xPosition + columnSpacing * 2.02, currentYPosition + 5);
            }


            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Blue color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasDistrict) {
                doc.text(districtName, xPosition + 28, currentYPosition + 5);  // District name (dynamic)
            }
            if (hasSubDivision) {
                doc.text(capitalizeFirstLetter(subDivisionName), xPosition + columnSpacing + 45, currentYPosition + 5);  // Sub Division name (dynamic)
            }
            if (hasBlock) {
                doc.text(blockName, xPosition + columnSpacing * 1.92 + 28, currentYPosition + 5);  // Block name (dynamic)
            }


            currentYPosition += 8;  // Move down for the next row

            // Second Table (Panchayat, FPS ID)
            if (hasPanchayat || hasFps) {
                // Second Table (Panchayat, FPS ID)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

                // Set font to normal for labels (Panchayat, FPS ID)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels only if data exists
                if (hasPanchayat) {
                    doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
                }
                if (hasFps) {
                    doc.text("FPS ID:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }


                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Green color for dynamic data

                // Add dynamic data only if the corresponding field exists
                if (hasPanchayat) {
                    let firstName = panchayatName;
                    doc.text(firstName, xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
                }
                if (hasFps) {
                    doc.text(fpsName, xPosition + columnSpacing + 45, currentYPosition + 5);  // FPS ID (dynamic)
                }


                currentYPosition += 8;  // Move down for the next row

                // If third table has data, show it
                if (hasFromDate || hasToDate) {
                    // Third Table (From Date, To Date)
                    doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                    // Set font to normal for labels (From Date, To Date)
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(0, 0, 0);  // Set text color to black for labels


                    // Add labels for From Date and To Date
                    if (hasFromDate) {
                        doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                    }
                    if (hasToDate) {
                        doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                    }


                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                    // Add dynamic data for From Date and To Date
                    if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                    if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)


                    currentYPosition += 8;  // Move down for the next row
                }
            }

            // If second table has no data, show third table (From Date, To Date)
            else if (!hasPanchayat && !hasFps && (hasFromDate || hasToDate)) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels

                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }

        // If the first table has no data, show second table (Panchayat, FPS ID) if it has data
        else if (hasPanchayat || hasFps) {
            // Second Table (Panchayat, FPS ID)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the second table

            // Set font to normal for labels (Panchayat, FPS ID)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels only if data exists
            if (hasPanchayat) {
                doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
            }
            if (hasFps) {
                doc.text("FPS ID:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Green color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasPanchayat) {
                let firstName = panchayatName;
                doc.text(firstName, xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
            }
            if (hasFps) {
                doc.text(fpsName, xPosition + columnSpacing + 45, currentYPosition + 5);  // FPS ID (dynamic)
            }


            currentYPosition += 8;  // Move down for the next row

            // If third table has data, show it
            if (hasFromDate || hasToDate) {
                // Third Table (From Date, To Date)
                doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

                // Set font to normal for labels (From Date, To Date)
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);  // Set text color to black for labels


                // Add labels for From Date and To Date
                if (hasFromDate) {
                    doc.text("From Date:", xPosition + 5, currentYPosition + 5);
                }
                if (hasToDate) {
                    doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
                }

                doc.setFont("helvetica", "bold");
                doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

                // Add dynamic data for From Date and To Date
                if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
                if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

                currentYPosition += 8;  // Move down for the next row
            }
        }

        // If the second table has no data, show the third table (From Date, To Date)
        else if (hasFromDate || hasToDate) {
            // Third Table (From Date, To Date)
            doc.rect(xPosition, currentYPosition, columnSpacing * 3, 8);  // Top border of the third table

            // Set font to normal for labels (From Date, To Date)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            // Add labels for From Date and To Date
            if (hasFromDate) {
                doc.text("From Date:", xPosition + 5, currentYPosition + 5);
            }
            if (hasToDate) {
                doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }


            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Orange color for dynamic data
            // Add dynamic data for From Date and To Date
            if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
            if (hasToDate) doc.text(toDate, xPosition + columnSpacing + 45, currentYPosition + 5);  // To Date (dynamic)

            currentYPosition += 8;  // Move down for the next row
        }

        currentYPosition += 5;  // Adjust space for next content if needed

        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Set the position for the current date and time
        // const dateYPosition = titleYPosition+35; // Position the date just below the title

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, pageWidth - 11, currentYPosition + 8, { align: 'right' });
        currentYPosition += 5;

        currentYPosition += 5;  // Adjust space for next content if needed

        // Table Column Titles
        const headers = [
            [
                { content: 'S. No', rowSpan: 2 },
                { content: 'District', rowSpan: 2 },
                { content: 'Total FPS', rowSpan: 2 },
                { content: 'No.of Unique FPS', rowSpan: 2 },
                { content: 'No.of FPS With Stock Deviation', rowSpan: 2 },
                { content: 'Type of Deviation', colSpan: 2 },
                { content: 'Quantity of Deviation  ( Qtl )', colSpan: 2 },
                { content: 'Action Taken', colSpan: 3 },
                { content: 'Status', colSpan: 2 },

            ],
            // Second row (sub-headers)
            [
                { content: 'Excess' },
                { content: 'Shortfall' },
                { content: 'Rice' },
                { content: 'Wheat' },
                { content: 'Notice' },
                { content: 'Suspension of License' },
                { content: 'FIR' },
                { content: 'Open' },
                { content: 'Closed' },
            ],


        ];
        // Repeat the stockData 15 times

        // Prepare the data rows for the table
        const rows = stockData.map((data, index) => [
            index + 1,
            capitalizeFirstLetter(data.districtName),
            capitalizeFirstLetter(data.subDivisionName),
            capitalizeFirstLetter(data.blockName),
            capitalizeFirstLetter(data.panchayatName),
            formatFullName(data.officerName),
            new Date(data.startTime).toLocaleDateString('en-GB').replace(/\//g, '-'),
            data.fpsId,
            data.phhRice || 'N/A',
            data.aayRice || 'N/A',
            data.phhWheat || 'N/A',
            data.aayWheat || 'N/A',
            data.ricePhysical || 'N/A',
            data.wheatPhysical || 'N/A',
            // data.wheatDiff||'N/A',
            parseFloat(data.riceDiff || 'N/A').toFixed(2),
            parseFloat(data.wheatDiff || 'N/A').toFixed(2),



        ]);

        // AutoTable Plugin - Adding Table to PDF
        doc.autoTable({
            head: headers,
            body: rows,
            startY: currentYPosition,

            theme: 'grid',
            headStyles: {
                fontStyle: 'bold',  // Make the header text bold
                textColor: [12, 92, 108],  // White text color for header
                fillColor: [242, 242, 242],  // White text color
                fontSize: 10,
            },
            margin: { top: 30, left: 7 },
            columnStyles: {
                // 0: { cellWidth: 11.5, halign: 'center' },   // S. No.
                // 1: { cellWidth: 16, halign: 'left' },   // Block
                // 2: { cellWidth: 25, halign: 'left' },   // Panchayat
                // 3: { cellWidth: 22, halign: 'left' },   // Date of Inspection
                // 4: { cellWidth: 25, halign: 'left' },   // Inspection Officer
                // 5: { cellWidth: 26.5, halign: 'left' },   // FPS ID
                // 6: { cellWidth: 22, halign: 'right' },   // Wheat PHH
                // 7: { cellWidth: 15, halign: 'right' },   // Wheat AYY
                // 8: { cellWidth: 15, halign: 'right' },   // Rice PHH
                // 9: { cellWidth: 15, halign: 'right' },   // Rice AYY
                // 10: { cellWidth: 15, halign: 'right' },  // Physical Stock Rice
                // 11: { cellWidth: 15, halign: 'right' },  // Physical Stock Wheat
                // 12: { cellWidth: 15, halign: 'right' },  // Stock Difference Rice
                // 13: { cellWidth: 15, halign: 'right' },  // Stock Difference Wheat
                // 14: { cellWidth: 15, halign: 'right' },  // Stock Difference Rice
                // 15: { cellWidth: 15, halign: 'right' },  // Stock Difference Wheat
                // 16: { cellWidth: 15, halign: 'right' },  // Stock Difference Rice
                // 17: { cellWidth: 15, halign: 'right' },  // Stock Difference Wheat


            },

        });

        // Save the PDF
        doc.save("Report_on_Action_Taken_During_Zero_Office_Day_(ZOD).pdf");


    };

    const sortData = (data) => {
        return data.sort((a, b) => {
            const districtA = a.districtName || '';
            const districtB = b.districtName || '';
            const subDivisionA = a.subDivisionName || '';
            const subDivisionB = b.subDivisionName || '';
            const blockA = a.blockName || '';
            const blockB = b.blockName || '';
            const panchayatA = a.panchayatName || '';
            const panchayatB = b.panchayatName || '';

            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return -1;
            if (districtA > districtB) return 1;
            if (subDivisionA < subDivisionB) return -1;
            if (subDivisionA > subDivisionB) return 1;
            if (blockA < blockB) return -1;
            if (blockA > blockB) return 1;
            if (panchayatA < panchayatB) return -1;
            if (panchayatA > panchayatB) return 1;
            return 0;
        });
    };


    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each 
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };


    const formatDate = (date) => {
        if (!date) return null;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const handleGenerateReport = () => {
        setIsLoading(true);
        setShowTable(true);
        // Case 1: Ensure start date is before end date (basic validation)
        if (startDate && endDate && startDate > endDate) {
            setError("Start date cannot be later than end date.");
            alert("Start date cannot be later than end date.");
            return;
        }


        setStockData([]);  // Clear previous stock data

        // Prepare request data
        const requestData = {
            startDate: startDate ? formatDate(startDate) : null,
            endDate: endDate ? formatDate(endDate) : null
        };

        axios.post(`${process.env.REACT_APP_API_BASE_URL}/reports/zod-with-filters`, requestData)
            .then((res) => {
                console.log("API Response:", res.data);
                setSortedStockData(res.data);
                setShowTable(true);

            })
            .catch((err) => {
                console.error("Error fetching data:", err);
                setSortedStockData([]); // reset data on error
                setShowTable(true)
            })
            .finally(() => {
                setIsLoading(false); // 🔹 Stop loading after API finishes
            });

    };



    // 🔹 Fetch data automatically when component loads
    // useEffect(() => {
    //     const currentDate = new Date();
    //     const formattedDate = `${String(currentDate.getFullYear())}-${String(
    //         currentDate.getMonth() + 1
    //     ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(2, "0")}`;

    //     const payload = { startDate: formattedDate };
    //     setFromDate("29-08-2025");  // You can make this dynamic if needed
    //     setToDate(
    //         `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`
    //     );
    //     console.log("Sending payload on page load:", payload);
    //     setShowTable(true);       // ✅ Show table immediately

    //     setIsLoading(true); // 🔹 Start loading before API call
    //     axios
    //         .post(`${process.env.REACT_APP_API_BASE_URL}/reports/action-taken-report-status`, payload)

    //         .then((res) => {
    //             console.log("API Response:", res.data);
    //             setSortedStockData(res.data);
    //             setShowTable(true);

    //         })
    //         .catch((err) => {
    //             console.error("Error fetching data:", err);
    //             setSortedStockData([]); // reset data on error
    //             setShowTable(true)
    //         })
    //         .finally(() => {
    //             setIsLoading(false); // 🔹 Stop loading after API finishes
    //         });
    // }, []);


    const generateXl = () => {
        // 1. Get the current date in DD-MM-YYYY format
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // 2. Generate Excel file using ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('ATR ZOD Report With Filters');
        worksheet.mergeCells('A1:AH1'); // Merge cells for the title
        worksheet.getCell('A1').value = `ATR ZOD Report With Filters.`; // Add spaces before date to shift it

        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };

        worksheet.mergeCells('A2:AH2'); // Merge cells for the title
        worksheet.getCell('A2').value = `Report Date: ${formattedDateTime}`; // Add spaces before date to shift it

        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };
        worksheet.getCell('A2').font = { size: 13, bold: true, color: { argb: '00000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };

        worksheet.mergeCells('A3:AH3'); // Merge cells for the title
        worksheet.getCell('A3').value = `From Date: ${format(startDate,'dd-MM-yyyy')}                  To Date: ${format(endDate,'dd-MM-yyyy')}`; // Add spaces before date to shift it

        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A3').font = { size: 13, bold: true, color: { argb: '00000' } };  // Text color: Light Steel Blue (ARGB format) black 000000
        worksheet.getCell('A3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        // Define the header row
        // Define the header row with merged cells for multi-column headers
        worksheet.addRow([
            "S.No",
            "District",
            "Sub Division",
            "Total FPS",
            "Total FPS Shops Inspected",
            "Action taken on Stock Deviation",
            "",
            " ",
            "",
            " ",
            " ",
            "Action taken on underweight food grains",
            "",
            " ",
            "",
            " ",
            " ",
            "Action taken on the poor quality of food grains",
            " ",
            " ",
            " ",
            " ",
            " ",
            "Action taken on no distribution of food grains",
            " ",
            " ",
            " ",
            " ",
            " ",
            "Action taken on Closed Shops",
            " ",
            " ",
            " ",
            " ",
            " ",

        ]);

        // Merge and set header values
        worksheet.mergeCells('F4:J4');
        worksheet.getCell('F4').value = "Action taken on Stock Deviation";

        worksheet.mergeCells('K4:O4');
        worksheet.getCell('K4').value = "Action taken on underweight food grains";

        worksheet.mergeCells('P4:T4');
        worksheet.getCell('P4').value = "Action taken on the poor quality of food grains";

        worksheet.mergeCells('U4:Y4');
        worksheet.getCell('U4').value = "Action taken on no distribution of food grains";

        worksheet.mergeCells('Z4:AD4');
        worksheet.getCell('Z4').value = "Action taken on Closed Shops";

        worksheet.mergeCells('AE4:AH4');
        worksheet.getCell('AE4').value = "Summary";
        // Adding sub-headers with the row spans and column spans
        worksheet.addRow([
            "",  // S.No
            "",  // District
            "",  // SubDivision
            "",  // fps
            "", //totalFpsinspected

            "Total Stock Deviations",
            "Total number of show cause notices issued to Fair Price Shops (FPS)",
            "Total number of FIR to Fair Price Shops (FPS)",
            "Total number of show cause Revoked issued to Fair Price Shops (FPS)",
            "Total FPS licenses cancelled",

            "Beneficiary feedback on the distribution of underweight food grains",
            "Total number of show cause notices issued to Fair Price Shops (FPS)",
            "Total number of FIR to Fair Price Shops (FPS)",
            "Total number of show cause Revoked issued to Fair Price Shops (FPS)",
            "Total FPS licenses cancelled",

            "Feedback from beneficiaries on the poor quality of distributed food grains",
            "Total number of show cause notices issued to Fair Price Shops (FPS)",
            "Total number of FIR to Fair Price Shops (FPS)",
            "Total number of show cause Revoked issued to Fair Price Shops (FPS)",
            "Total FPS licenses cancelled",

            "Beneficiaries reported that food grains were not distributed",
            "Total number of show cause notices issued to Fair Price Shops (FPS)",
            "Total number of FIR to Fair Price Shops (FPS)",
            "Total number of show cause Revoked issued to Fair Price Shops (FPS)",
            "Total FPS licenses cancelled",


            "Total Shops Closed",
            "Total number of show cause notices issued to Fair Price Shops (FPS)",
            " Total number of FIR to Fair Price Shops (FPS)",
            "Total number of show cause Revoked issued to Fair Price Shops (FPS)",
            "Total FPS licenses cancelled",


            "Total Show Cause Notice",
            "Total FIR",
            "Total Show Cause Revoked",
            "Total Licenses Cancelled",

        ]);

        // Apply header style: bold, size 12, and orange background
        worksheet.getRow(4).font = { bold: true, size: 12 };
        worksheet.getRow(4).alignment = { horizontal: 'center' }; // Center alignment
        worksheet.getRow(5).alignment = { horizontal: 'center' };
        // Apply background color to the first row (header row)
        for (let col = 1; col <= 34; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }
        for (let col = 1; col <= 34; col++) {
            const cell = worksheet.getCell(5, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }

        // Adjust column widths (ensure to set widths based on your content)
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A: S.No
            { key: 'B', width: 20 },  // Column B: District
            { key: 'C', width: 25 },  // Column C: SubDivision
            { key: 'D', width: 17 },  // Column D: Block
            { key: 'E', width: 27 },  // Column E: Panchayat
            { key: 'F', width: 35 },  // Column F: Officer Name
            { key: 'G', width: 75 },  // Column G: Date of Inspection
            { key: 'H', width: 40 },  // Column F: FPS ID
            { key: 'I', width: 35 },  // Column H: e-POS Stock Wheat
            { key: 'J', width: 75 },  // Column I: e-POS Stock Wheat (AYY Qty)
            { key: 'K', width: 35 },  // Column J: e-POS Stock Rice
            { key: 'L', width: 70 },  // Column K: e-POS Stock Rice (AYY Qty)
            { key: 'M', width: 75 },  // Column L: Physically Verified Quantity (Rice, Wheat)
            { key: 'N', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'O', width: 70 },  // Column K: e-POS Stock Rice (AYY Qty)
            { key: 'P', width: 75 },  // Column L: Physically Verified Quantity (Rice, Wheat)
            { key: 'Q', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'R', width: 70 },  // Column K: e-POS Stock Rice (AYY Qty)
            { key: 'S', width: 75 },  // Column L: Physically Verified Quantity (Rice, Wheat)
            { key: 'T', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'U', width: 30 },
            { key: 'V', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'W', width: 30 },
            { key: 'X', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'Y', width: 30 },
            { key: 'Z', width: 30 },
            { key: 'AA', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'AB', width: 30 },
            { key: 'AC', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'AD', width: 30 },
            { key: 'AE', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'AF', width: 30 },
            { key: 'AG', width: 30 },  // Column M: Difference in ePos and Physical Stock (Rice, Wheat)
            { key: 'AH', width: 30 },
        ];
        // Add data rows
        sortedStockData.forEach((data, index) => {
            const dataRow = worksheet.addRow([
                index + 1,
                capitalizeFirstLetter(data.districtName),
                capitalizeFirstLetter(data.subDivisionName),
                data.totalFps,
                data.totalFpsInspected,

                data.stockDeviation,
                data.showCauseStock,
                data.firStock,
                data.revokedStock,
                data.licensesCancelledStock,

                data.underWeightComplaints,
                data.showCauseLess,
                data.firLess,
                data.revokedLess,
                data.licensesCancelledLess,

                data.badComplaints,
                data.showCaluseBad,
                data.firBad,
                data.revokedBad,
                data.licensesCancelledBad,

                data.noDisComplaints,
                data.showCauseNoDistribution,
                data.firNoDistribution,
                data.revokedNoDistribution,
                data.licensesCancelledNoDistribution,

                data.shopClosed,
                data.showCauseClosed,
                data.firClosed,
                data.revokedClosed,
                data.licensesCancelledClosed,


                data.totalNotices,
                data.totalFir,
                data.totalRevoke,
                data.totalCancelled,

                // parseFloat(data.riceDiff || 'N/A').toFixed(2),
                // // data.wheatDiff||0,
                // parseFloat(data.wheatDiff || 'N/A').toFixed(2),


            ]);

            // Apply alignment for each cell in the data row
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {
                    // Center alignment for S.No (Serial Number)
                    cell.alignment = { horizontal: 'center' };
                } else if (colNumber >= 2 && colNumber <= 3) {
                    // Left alignment for District to Officer Name (columns 2 to 6)
                    cell.alignment = { horizontal: 'left' };
                } else if (colNumber >= 4 && colNumber <= 14) {
                    // Right alignment for Date of Inspection to Difference in ePos and Physical Stock (columns 7 to 16)
                    cell.alignment = { horizontal: 'right' };
                }
            });
        });



        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'ATR_ZOD_Report_With_Filters.xlsx';
            link.click();
        });

    };
    return (
        <div className="action-Taken-with-filters-repo">
            <div className="action-Taken-with-filters-devi-buttons">
                {/* <button onClick={generatePDF} className="action-Taken-with-filters-buttons">
                                        DOWNLOAD PDF
                                    </button> */}
                {/* <button onClick={generateXl} className="action-Taken-with-filters-buttons">
                    DOWNLOAD XLSX
                </button> */}
                <div className="action-Taken-with-filters-boxes-bars">
                    <div className="action-Taken-with-filters-card-head">ATR ZOD Report With Filters</div>
                    <div className='fps-whole-div'>


                        <div className="action-Taken-with-filters-block-2">

                            <div className="action-Taken-with-filters">
                                <label htmlFor="startDateP" ><span className="asterisk">*</span>From Date</label>
                                <div className="action-Taken-with-filters-stock-repo-insp">
                                    <input
                                        type="text"
                                        id="startDateP"
                                        className="action-Taken-with-filters-input-repo"
                                        value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                                        readOnly
                                        onClick={() => setShowCalendar(true)}
                                    />
                                    <div className="action-Taken-with-filters-icon" onClick={() => setShowCalendar(true)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                            <path d="M7 10l5 5 5-5z" />
                                        </svg>
                                    </div>
                                    {showCalendar && (
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            onClickOutside={() => setShowCalendar(false)}
                                            inline
                                            //  minDate={minstartDate} // From January 1st of current year
                                            maxDate={currentDate} // Today
                                        />
                                    )}
                                </div>
                            </div>


                            <div className="action-Taken-with-filters">
                                <label htmlFor="startDateP" ><span className="asterisk">*</span>To Date</label>
                                <div className="action-Taken-with-filters-stock-repo-insp">
                                    <input
                                        type="text"
                                        id="startDateP"
                                        className="action-Taken-with-filters-input-repo"
                                        value={endDate ? format(endDate, 'dd-MM-yyyy') : ''}
                                        readOnly
                                        onClick={() => setShowEndCalendar(true)}
                                        disabled={!startDate}
                                    />
                                    <div className="action-Taken-with-filters-icon" onClick={handleEndDateIconClick}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                            <path d="M7 10l5 5 5-5z" />
                                        </svg>
                                    </div>
                                    {showEndCalendar && (
                                        <DatePicker
                                            selected={endDate}

                                            onChange={handleEndDateChange}
                                            onClickOutside={() => setShowEndCalendar(false)}
                                            //  minDate={minendDateP} // Disable dates before startDateP
                                            inline
                                            minDate={startDate} // End date can't be before the start date
                                            maxDate={currentDate} // End date can't be after today
                                        />
                                    )}
                                </div>
                            </div>


                            <div className="action-Taken-with-filters-group-2">
                                <div className="action-Taken-with-filters-group-4">
                                    <button className="action-Taken-with-filters-button" onClick={handleClear}
                                        disabled={
                                            // Button is disabled if no districtId or fpsId is provided AND no startDateP and endDateP are provided
                                            !(startDate && endDate)
                                        }
                                    >CLEAR
                                    </button>


                                    <button
                                        className="action-Taken-with-filters-button"
                                        onClick={handleGenerateReport}
                                        disabled={
                                            // Button is disabled if no districtId or fpsId is provided AND no startDateP and endDateP are provided
                                            !(startDate && endDate)
                                        }  // Disable if any field is not selected
                                    // disabled={!districtId }
                                    >
                                        GENERATE REPORT
                                    </button>
                                </div>
                            </div>

                        </div>

                        <div className="action-Taken-with-filters-block-3">
                            <div className="action-Taken-with-filters-group-2">
                                <div className="action-Taken-with-filters-group-4">


                                </div>
                            </div>

                            <div className="action-Taken-with-filters-group-2">
                                <div className="action-Taken-with-filters-group-4">




                                </div>
                            </div>
                            <div className="action-Taken-with-filters">

                                {(startDate && endDate) && showTable && (
                                    <div className="action-Taken-with-filters-group-4">
                                        {/* <button onClick={generatePDF} className="   action-Taken-with-filters-button">
                                            DOWNLOAD PDF
                                        </button> */}
                                         
                                        <button onClick={generateXl} className="action-Taken-with-filters-button">
                                            DOWNLOAD XLSX
                                        </button>
                                    </div>
                                )}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <div className="action-Taken-with-filters-main-repo">
                <table className="action-Taken-with-filters-table-repo">
                    {/* <thead>
                        <tr>
                            <th colSpan={34}>
                                <span className="zod-title"> ATR Report - Zero Office Day</span>
                                <div className="discrepancy-date-range">
                                    <span style={{ color: "#2a6d86", fontWeight: "Normal" }}>From Date : </span> {fromDate} &nbsp;&nbsp;
                                    <span style={{ color: "#2a6d86", fontWeight: "Normal" }}>To Date : </span> {toDate}
                                </div>
                            </th>
                        </tr>
                    </thead> */}
                    <thead>
                        <tr>

                            <th rowSpan="2">S.No</th>
                            <th rowSpan="2">District</th>
                            <th rowSpan="2">Sub Division</th>
                            <th rowSpan="2">Total FPS</th>
                            <th rowSpan="2">Total FPS Shops Inspected</th>
                            <th colSpan="5" >Action taken  on Stock Deviation</th>
                            <th colSpan="5" >Action taken  on underweight food
                                grains</th>
                            <th colSpan="5">Action taken on the poor quality of
                                food grains</th>
                            <th colSpan="5">Action taken on no distribution of food grains</th>
                            <th colSpan="5">Action taken on Closed Shops</th>
                            <th colSpan="4">Summary</th>
                        </tr>
                        <tr>
                            {/* Stock Deviation */}
                            <th className="group0">Total Stock Deviations</th>
                            <th className="group0">Total number of show
                                cause notices issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group0">Total number of FIR to
                                Fair Price Shops (FPS)</th>
                            <th className="group0">Total number of show
                                cause Revoked issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group0">Total FPS licenses
                                cancelled</th>

                            {/* No underweight */}
                            <th className="group1">Beneficiary feedback on
                                the distribution of
                                underweight food grains</th>
                            <th className="group1">Total number of show
                                cause notices issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group1">Total number of FIR to
                                Fair Price Shops (FPS)</th>
                            <th className="group1">Total number of show
                                cause Revoked issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group1">Total FPS licenses
                                cancelled</th>
                            {/* Bad Quantity */}
                            <th className="group2">Feedback from beneficiaries
                                on the poor quality of
                                distributed food grains</th>
                            <th className="group2">Total number of show
                                cause notices issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group2">Total number of FIR to
                                Fair Price Shops (FPS)</th>
                            <th className="group2">Total number of show
                                cause Revoked issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group2"> Total FPS
                                licenses
                                cancelled</th>
                            {/* No distributed */}
                            <th className="group3">Beneficiaries reported
                                that food grains were
                                not distributed</th>
                            <th className="group3">Total number of show
                                cause notices issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group3">Total number of FIR to
                                Fair Price Shops (FPS)</th>
                            <th className="group3">Total number of show
                                cause Revoked issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group3">Total FPS licenses
                                cancelled</th>

                            {/* Shop Closed */}
                            <th className="group4">Total Shops Closed</th>
                            <th className="group4">Total number of show
                                cause notices issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group4">Total number of FIR to
                                Fair Price Shops (FPS)</th>
                            <th className="group4">Total number of show
                                cause Revoked issued to
                                Fair Price Shops (FPS)</th>
                            <th className="group4">Total FPS licenses
                                cancelled</th>

                            {/* Summary */}
                            <th className="group5">Total Show Cause Notices</th>
                            <th className="group5">Total FIR</th>
                            <th className="group5">Total Show Cause Revoked</th>
                            <th className="group5">Total Licenses Cancelled</th>

                        </tr>
                    </thead>

                    {showTable && (
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="34" style={{ textAlign: "center" }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : sortedStockData.length > 0 ? (
                                sortedStockData.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{capitalizeFirstLetter(entry.districtName)}</td>
                                        <td>{capitalizeFirstLetter(entry.subDivisionName)}</td>
                                        <td>{entry.totalFps}</td>
                                        <td>{entry.totalFpsInspected}</td>
                                        {/* Stock Deviation */}
                                        <td>{entry.stockDeviation}</td>
                                        <td>{entry.showCauseStock}</td>
                                        <td>{entry.firStock}</td>
                                        <td>{entry.revokedStock}</td>
                                        <td>{entry.licensesCancelledStock}</td>
                                        {/* Less Quantity */}
                                        <td>{entry.underWeightComplaints}</td>
                                        <td>{entry.showCauseLess}</td>
                                        <td>{entry.firLess}</td>
                                        <td>{entry.revokedLess}</td>
                                        <td>{entry.licensesCancelledLess}</td>
                                        {/* Bad Quality */}
                                        <td>{entry.badComplaints}</td>
                                        <td>{entry.showCaluseBad}</td>
                                        <td>{entry.firBad}</td>
                                        <td>{entry.revokedBad}</td>
                                        <td>{entry.licensesCancelledBad}</td>
                                        {/* No Distribution */}
                                        <td>{entry.noDisComplaints}</td>
                                        <td>{entry.showCauseNoDistribution}</td>
                                        <td>{entry.firNoDistribution}</td>
                                        <td>{entry.revokedNoDistribution}</td>
                                        <td>{entry.licensesCancelledNoDistribution}</td>

                                        {/* Shop Closed */}
                                        <td>{entry.shopClosed}</td>
                                        <td>{entry.showCauseClosed}</td>
                                        <td>{entry.firClosed}</td>
                                        <td>{entry.revokedClosed}</td>
                                        <td>{entry.licensesCancelledClosed}</td>

                                        {/* Summary */}
                                        <td>{entry.totalNotices}</td>
                                        <td>{entry.totalFir}</td>
                                        <td>{entry.totalRevoke}</td>
                                        <td>{entry.totalCancelled}</td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="34" style={{ textAlign: "center", color: "red" }}>
                                        No Data Available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}

                </table>
            </div>

        </div>
    );
}
export default ATRZODReportWithFilters;